import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

// 📌 路由設定（使用 module_key）
const routes = [
  { path: '/', redirect: '/login' },

  { path: '/login', name: 'LoginForm', component: () => import("@/components/LoginForm.vue") },

  // 仪表板
  { path: '/dashboard', component: () => import("@/components/AdminDashboard.vue"), meta: { module: 'dashboard' } },
  { path: '/orderDashboard', component: () => import("@/components/OrderDashboard.vue"), meta: { module: 'financial_dashboard' } },
  { path: '/purchaseDashboard', component: () => import("@/components/PurchaseDashboard.vue"), meta: { module: 'purchase_dashboard' } },
  { path: '/salesDashboard', component: () => import("@/components/SalesDashboard/SalesDashboard.vue"), meta: { module: 'sales_dashboard' } },
  { path: '/salesFollowUp', redirect: '/salesDashboard' }, // 業務跟進已整合進銷售儀表板
  { path: '/cash-flow-dashboard', component: () => import("@/views/CashFlowDashboard.vue"), meta: { module: 'cash_flow_dashboard' } },
  { path: '/knowledge/:articleId?', component: () => import("@/components/Knowledge/KnowledgeLibrary.vue"), meta: { module: 'knowledge' } },
  {
    path: '/dailyMarketingDashboard',
    name: 'DailyMarketingDashboard',
    component: () => import("@/components/DailyMarketing/DailyMarketingDashboard.vue"),
    meta: { module: 'daily_marketing' }
  },
  {
    path: '/dailyMarketingDataDashboard',
    name: 'DailyMarketingDataDashboard',
    component: () => import("@/components/DailyMarketing/DailyMarketingDataDashboard.vue"),
    meta: { module: 'daily_marketing' }
  },
  {
    path: '/dailyMarketingDashboard/:date',
    name: 'DailyMarketingDetail',
    component: () => import("@/components/DailyMarketing/DailyMarketingDetail.vue"),
    meta: { module: 'daily_marketing' }
  },
  {
    path: '/marketingLoop',
    name: 'MarketingLoopConsole',
    component: () => import("@/components/MarketingLoop/MarketingLoopConsole.vue"),
    meta: { module: 'daily_marketing' }
  },
  {
    path: '/marketIntel',
    name: 'MarketIntel',
    component: () => import("@/components/MarketIntel/MarketIntelPage.vue"),
    meta: { module: 'market_intel' }
  },
  {
    path: '/marketIntel/companies/:id',
    name: 'MarketIntelCompany',
    component: () => import("@/components/MarketIntel/MarketIntelCompanyPage.vue"),
    meta: { module: 'market_intel' }
  },

  // 客戶 / 產品 / 訂單
  { path: '/userClients', component: () => import("@/components/Client/UserClients.vue"), meta: { module: 'clients' } },
  { path: '/userProducts', component: () => import("@/components/Product/UserProducts.vue"), meta: { module: 'products' } },
  { path: '/productComposition', component: () => import("@/components/Product/ProductComposition.vue"), meta: { module: 'products' } },
  { path: '/customerPartNumbers', component: () => import("@/components/Product/CustomerPartNumbers.vue"), meta: { module: 'products' } },
  { path: '/procurementTodos', component: () => import("@/components/Purchase/ProcurementTodos.vue"), meta: { module: 'purchase_orders' } },
  { path: '/userMaterials', component: () => import("@/components/Materials/UserMaterials.vue"), meta: { module: 'materials' } },
  { path: '/userOrders', component: () => import("@/components/Orders/UserOrders.vue"), meta: { module: 'orders', scrollTarget: '#user-orders-title' } },
  { path: '/userWarehouse', component: () => import("@/components/Warehouse/UserWarehouse.vue"), meta: { module: 'warehouse' } },

  // 盤點管理
  {
    path: '/stocktaking',
    name: 'StocktakingList',
    component: () => import("@/components/Stocktaking/StocktakingList.vue"),
    meta: { module: 'warehouse' }
  },
  {
    path: '/stocktaking/:id',
    name: 'StocktakingDetail',
    component: () => import("@/components/Stocktaking/StocktakingDetail.vue"),
    meta: { module: 'warehouse' }
  },

  // 生產計畫
  { path: '/productionPlans', component: () => import("@/components/ProductionPlan/ProductionPlans.vue"), meta: { module: 'production' } },
  { path: '/productionPlansMonthly', component: () => import("@/components/ProductionPlan/ProductionPlansMonthly.vue"), meta: { module: 'production' } },
  { path: '/transitionBacklog', component: () => import("@/components/ProductionPlan/TransitionBacklog.vue"), meta: { module: 'production' } },

  // 送貨單
  { path: '/deliveryOrders', component: () => import("@/components/DeliveryOrders/DeliveryOrders.vue"), meta: { module: 'delivery_orders', scrollTarget: '#delivery-orders-title' } },
  { path: '/deliveryOrderDetails', component: () => import("@/components/DeliveryOrders/DeliveryOrderDetails.vue"), meta: { module: 'delivery_orders', scrollTarget: '#delivery-order-details-title' } },

  // 報價
  { path: '/quotesheets', component: () => import("@/components/Quote/QuoteSheets.vue"), meta: { module: 'quotes' } },

  // 財務
  { path: '/invoiceDashboard', component: () => import("@/components/Invoice/InvoiceDashboard.vue"), meta: { module: 'invoice' } },
  {
    path: "/invoiceForeignDashboard",
    component: () => import("@/components/Invoice/ForeignInvoiceDashboard.vue"),
    meta: { module: "invoice_foreign" },
  },
  { path: '/monthlyInvoiceDashboard', component: () => import("@/components/AnnualDashboard/MonthlyInvoiceDashboard.vue"), meta: { module: 'invoice_monthly' } },
  { path: '/accountsReceivableDashboard', component: () => import("@/components/AccountsReceivable/AccountsReceivableDashboard.vue"), meta: { module: 'accounts_receivable' } },
  { path: '/reconciliation', component: () => import("@/components/Reconciliation/reconciliation.vue"), meta: { module: 'reconciliation', scrollTarget: '#reconciliation-title' } },
  { path: '/rmbAnnualReconciliation', component: () => import("@/components/AnnualDashboard/RmbAnnualReconciliation.vue"), meta: { module: 'rmb_annual_reconciliation' } },
  { path: '/usdAnnualReconciliation', component: () => import("@/components/AnnualDashboard/UsdAnnualReconciliation.vue"), meta: { module: 'usd_annual_reconciliation' } },
  // { path: '/rmbInvoiceList', component: () => import("@/components/Reconciliation/RmbInvoiceList.vue"), meta: { module: 'rmb_invoice_list' } }, // <-- 已移除
  // { path: '/usdInvoiceList', component: () => import("@/components/Reconciliation/UsdInvoiceList.vue"), meta: { module: 'usd_invoice_list' } }, // <-- 已移除

  { path: '/accountsPayableDashboard', component: () => import("@/components/AccountsPayable/AccountsPayableDashboard.vue"), meta: { module: 'accounts_payable' } },
  { path: '/accountsPayable', component: () => import("@/components/AccountsPayable/AccountsPayable.vue"), meta: { module: 'accounts_payable' } },
  { path: '/payments', component: () => import("@/components/AccountsPayable/Payments.vue"), meta: { module: 'payments' } },

  { path: '/exchangeRateManager', component: () => import("@/components/Curriencies/ExchangeRateManager.vue"), meta: { module: 'exchange_rate' } },

  // 供應商與採購
  { path: '/suppliers', component: () => import("@/components/Suppliers/Suppliers.vue"), meta: { module: 'suppliers' } },
  {
    path: '/purchase-orders',
    component: () => import("@/components/Purchase/PurchaseOrders.vue"),
    meta: {
      module: 'purchase_orders',
      scrollTarget: '#purchase-orders-title',
    },
  },

  // 樣品管理
  { path: '/sampleDelivery', component: () => import("@/components/SampleDelivery/SampleDelivery.vue"), meta: { module: 'samples' } },

  {
    path: "/rolePermissions",
    component: () => import("@/components/RolePermission/RolePermissionManager.vue"),
    meta: { module: "role_permissions" },
  },
  {
    // 系統說明圖沿用 role_permissions 權限＝僅管理員（canView 對 role_permissions 只放行 admin）
    path: "/systemDiagrams",
    component: () => import("@/components/SystemDiagrams/SystemDiagrams.vue"),
    meta: { module: "role_permissions" },
  },
  {
    path: "/userOthers",
    component: () => import("@/components/Others/UserOthers.vue"),
    meta: { module: "userOthers" },
  },
  {
    path: "/uploadFuncation1",
    component: () => import("@/components/Others/UploadFuncation1.vue"),
    meta: { module: "uploadFuncation1" },
  },
  {
    path: "/formurlaSpaceExplore",
    component: () => import("@/components/Engineering/FormurlaSpaceExplore.vue"),
    meta: { module: "formurlaSpaceExplore" },
  },
  {
    path: "/stockInvestment",
    component: () => import("@/components/StockInvestment/StockInvestmentPage.vue"),
    meta: { module: "stock_investment" },
  },
  {
    path: "/sensor-lab",
    name: "SensorLab",
    component: () => import("@/components/SensorLab/SensorLab.vue"),
    meta: { module: "sensor_lab" },
  },

  // 行政區管理
  { path: '/administrative-area/employee-attendance', component: () => import("@/components/AdministrativeArea/EmployeeAttendance.vue"), meta: { module: 'employee_attendance' } },
  { path: '/administrative-area/safety-supervision', component: () => import("@/components/AdministrativeArea/SafetySupervision.vue"), meta: { module: 'administrative_area' } },
  { path: '/administrative-area/occupational-health', component: () => import("@/components/AdministrativeArea/OccupationalHealth.vue"), meta: { module: 'administrative_area' } },
  { path: '/administrative-area/environmental-protection', component: () => import("@/components/AdministrativeArea/EnvironmentalProtection.vue"), meta: { module: 'administrative_area' } },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/components/NotFound.vue') },
];

// 🚨 Router 守衛：使用動態權限
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.meta?.scrollTarget) {
      return { el: to.meta.scrollTarget, top: 16 };
    }
    return undefined;
  },
});

const CHUNK_RELOAD_KEY = 'chunk-load-recovery';

router.onError((error) => {
  const message = error?.message || '';
  const isChunkLoadError = /ChunkLoadError|Loading chunk .* failed|dynamically imported module/i.test(message);

  if (isChunkLoadError && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }
});

router.afterEach(() => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.module) return next();

  if (to.meta.module === 'sensor_lab' && process.env.NODE_ENV === 'development') {
    return next();
  }

  if (!store.getters.isSessionReady) {
    await store.dispatch('restoreSession');
  }

  if (!store.getters.isAuthenticated) {
    return next('/login');
  }

  const moduleKey = to.meta.module;
  // 現金流儀表板、股票投資只給管理員（後端 authorization_policy 也同樣限制）
  if (moduleKey === 'cash_flow_dashboard' || moduleKey === 'stock_investment') {
    if (store.getters.isAdmin) {
      return next();
    }
    return next('/dashboard'); // Redirect non-admins
  }

  if (!store.getters.canView(moduleKey)) {
    return next('/dashboard');
  }

  next();
});

export default router;
